import { useEffect, useState, useRef } from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";

const CustomReactQuillEditor = ({
  value = "",
  onChange,
  readOnly = false,
  showCharCount = false,
  maxChars = 1000,
}) => {
  const { quill, quillRef } = useQuill({
    readOnly,
    theme: "snow",
    modules: {
      toolbar: readOnly
        ? false
        : [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["link"],
            [{ direction: "ltr" }],
            ["clean"],
          ],
      clipboard: {
        matchVisual: false,
      },
    },
    formats: [
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "list",
      "indent",
      "link",
      "direction",
    ],
  });

  const [charCount, setCharCount] = useState(0);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (quill && !hasInitialized.current) {
      hasInitialized.current = true;

      // Set initial content
      quill.clipboard.dangerouslyPasteHTML(value);

      // Set default text direction to LTR
      quill.root.setAttribute("dir", "ltr");

      // Move cursor to the end of the text
      const length = quill.getLength();
      quill.setSelection(length - 1, 0);

      // Listen to text changes
      quill.on("text-change", () => {
        const html = quill.root.innerHTML;
        if (onChange) onChange(html);
        if (showCharCount) setCharCount(html.replace(/<[^>]*>/g, "").length); // plain text count
      });

      // Track initial char count
      if (showCharCount)
        setCharCount((value || "").replace(/<[^>]*>/g, "").length);
    }
  }, [quill, value, onChange, showCharCount]);

  return (
    <div className="quill-antd-wrapper">
      <div ref={quillRef} />
      {showCharCount && (
        <div
          className="char-count"
          style={{
            textAlign: "right",
            marginTop: 4,
            fontSize: 12,
            color: charCount > maxChars ? "red" : "gray",
            padding: 2,
          }}
        >
          {charCount}/{maxChars} characters
        </div>
      )}
    </div>
  );
};

export default CustomReactQuillEditor;
